import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { GetCompanySimplifiedInterface } from '@/interfaces/company/getCompanySimplified.interface';
import type { SubsidiaryInterface } from '@/interfaces/subsidiary';

export const useSubsidiaryStore = defineStore(
  'AtenaSubsidiaryStore',
  () => {
    const subsidiary = ref<SubsidiaryInterface | null>(null);
    const simplifiedCompanyResponse = ref<GetCompanySimplifiedInterface[]>([]);

    const companies = computed(() => simplifiedCompanyResponse.value);

    const subsidiaries = computed(() => {
      const allSubsidiaries: Array<{ id: string; name: string }> = [];
      companies.value.forEach((company) => {
        if (company.subsidiaries) {
          allSubsidiaries.push(...company.subsidiaries);
        }
        if (company.id && company.name) {
          allSubsidiaries.push({ id: company.id, name: company.name });
        }
      });
      return allSubsidiaries;
    });

    const setCompanies = (payload: GetCompanySimplifiedInterface[]) => {
      simplifiedCompanyResponse.value = payload;
    };

    const clear = () => {
      subsidiary.value = null;
    };

    const setInformation = async (payload: SubsidiaryInterface) => {
      subsidiary.value = payload;
    };

    return {
      companies,
      subsidiaries,
      subsidiary,
      setCompanies,
      clear,
      setInformation,
    };
  },
  {
    persist: {
      storage: localStorage,
    },
  },
);
